import React from 'react';
import { FaStar } from 'react-icons/fa';
import './TestimonialCard.css';

function TestimonialCard({ testimonial }) {
  return (
    <div className="testimonial-card">
      <div className="stars">
        {[...Array(Math.floor(testimonial.rating))].map((_, i) => (
          <FaStar key={i} />
        ))}
      </div>
      <p className="testimonial-text">"{testimonial.text}"</p>
      <div className="testimonial-author">
        <div className="author-avatar">
          {testimonial.image ? (
            <img src={testimonial.image} alt={testimonial.name} />
          ) : (
            <span>{testimonial.name.charAt(0)}</span>
          )}
        </div>
        <div className="author-info">
          <h4>{testimonial.name}</h4>
          <p>{testimonial.title}</p>
        </div>
      </div>
    </div>
  );
}

export default TestimonialCard;
